import type { ReactNode } from 'react'
import entStyles from '../../styles/enterprise/EnterpriseOperationalUx.module.scss'

type Props = {
  layerLabel?: string
  title?: string
  subtitle?: ReactNode
  children: ReactNode
  testId?: string
  className?: string
}

export default function EnterpriseOperationalSection({
  layerLabel,
  title,
  subtitle,
  children,
  testId,
  className,
}: Props) {
  return (
    <section
      className={`${entStyles.layer} ${className || ''}`.trim()}
      data-testid={testId}
    >
      {layerLabel ? <p className={entStyles.layerLabel}>{layerLabel}</p> : null}
      <div className={entStyles.posturePanel}>
        {title ? <h2 className={entStyles.postureTitle}>{title}</h2> : null}
        {subtitle ? <p className={entStyles.postureSubtitle}>{subtitle}</p> : null}
        {children}
      </div>
    </section>
  )
}

export function EnterpriseOperationalCard({
  title,
  children,
  className,
}: {
  title?: string
  children: ReactNode
  className?: string
}) {
  return (
    <article className={`${entStyles.standardCard} ${className || ''}`.trim()}>
      {title ? <h3 className={entStyles.cardTitle}>{title}</h3> : null}
      {children}
    </article>
  )
}
